import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import './DeviceDetails.css';
import Loader from "../../../../../shared/loader/Loader";
import { Col, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import { SUCCESS } from "../../../../../../constants/AppConstants";

const DeviceDetails = ({ getUserDeviceStatus }) => {
    const { t } = useTranslation("CSAgenttranslation");
    const TABS = {
        'BROTHER_PLUS_DEVICE_DETAILS': 'BROTHER_PLUS_DEVICE_DETAILS'
    }
    const { deviceStatus, error, loading } = getUserDeviceStatus;

    const [activeTab, setActiveTab] = useState((deviceStatus?.deviceStatuses?.length > 0)
        ? deviceStatus?.deviceStatuses[0]?.deviceId
        : null);

    useEffect(() => {
        if (deviceStatus && deviceStatus?.actionStatus?.toUpperCase() === SUCCESS) {
            if ((deviceStatus?.deviceStatuses?.length > 0)) {
                setActiveTab(deviceStatus?.deviceStatuses[0]?.deviceId);
            } else {
                setActiveTab(TABS.BROTHER_PLUS_DEVICE_DETAILS);
            }
        }
    }, [TABS.BROTHER_PLUS_DEVICE_DETAILS, deviceStatus]);

    if (loading) {
        return <Loader />;
    }

    if (error) {
        return <div className="email-log-error">{t("ERROR_MESSAGES.DEVICE_NOT_FOUND")}</div>;
    }

    return (
        <div className="overview-container customer-details-wrapper mt-40">
            <div className="tab-btn-wrapper">
                <div>
                    <Nav tabs>
                        {(deviceStatus?.deviceStatuses?.length > 0) ?
                            deviceStatus?.deviceStatuses.map((device) => (
                                <NavItem>
                                    <NavLink active={activeTab === device.deviceId} onClick={() => setActiveTab(device.deviceId)}>
                                        {device.serialNumber}
                                    </NavLink>
                                </NavItem>
                            )) :
                            <NavItem>
                                <NavLink active={activeTab === TABS.BROTHER_PLUS_DEVICE_DETAILS} onClick={() => setActiveTab(TABS.BROTHER_PLUS_DEVICE_DETAILS)}>
                                    {t('CUSTOMER_DASHBOARD.TAB_ITEMS.BROTHERPLUS_DEVICE_DETAILS')}
                                </NavLink>
                            </NavItem>
                        }
                    </Nav>
                </div>
            </div>
            <div className="device-info-tab-contens">
                <TabContent activeTab={activeTab}>
                    {
                        (deviceStatus?.deviceStatuses?.length > 0) ?
                            deviceStatus?.deviceStatuses.map((device) => (
                                <TabPane tabId={device.deviceId}>
                                    <div className="overview-container mt-40">
                                        <div>
                                            <Row className="device-page-info-wrapper">
                                                <Col className="blocks move-left">
                                                    <div className="block-title">
                                                        <h5>{t('CUSTOMER_DASHBOARD.OVERVIEW.BROTHERPLUS_DEVICEDETAILS.PRINTED_PAGES')}</h5>
                                                    </div>
                                                    <div className="block-content">
                                                        <p><span>{device.printedPages}</span></p>
                                                    </div>
                                                </Col>
                                                <Col className="blocks move-left">
                                                    <div className="block-title">
                                                        <h5>{t('CUSTOMER_DASHBOARD.OVERVIEW.BROTHERPLUS_DEVICEDETAILS.AVERAGE_PAGES')}</h5>
                                                    </div>
                                                    <div className="block-content">
                                                        <p><span>{device.averagePages}</span></p>
                                                    </div>
                                                </Col>
                                                <Col className="blocks move-left">
                                                    <div className="block-title">
                                                        <h5>{t('CUSTOMER_DASHBOARD.OVERVIEW.BROTHERPLUS_DEVICEDETAILS.DUPLEX_PAGES')}</h5>
                                                    </div>
                                                    <div className="block-content">
                                                        <p><span>{device.duplexPages}</span></p>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="device-details-wrapper mt-40">
                                                <div className="header">
                                                    <div className="title">
                                                        <h1>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.TITLE')}</h1>
                                                    </div>
                                                </div>
                                                <div className="device-details-info mt-15">
                                                    <p>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.MODEL_NUMBER')}: <span>{device.model || 'N/A'}</span></p>
                                                    <p>{t('CUSTOMER_DASHBOARD.OVERVIEW.DEVICE_DETAILS.SERIAL_NUMBER')}: <span>{device.serialNumber}</span></p>
                                                </div>
                                            </div>

                                            <div className="device-details-wrapper mt-40">
                                                <div className="header">
                                                    <div className="title">
                                                        <h1>Cartridge details</h1>
                                                    </div>
                                                </div>
                                                <div className="device-details-info mt-15">
                                                    {
                                                        (device.genuineInfo !== null && device.genuineInfo !== undefined) ?
                                                            Object.entries(device.genuineInfo).map(([key, value]) => (
                                                                <p key={key}>{key}: <span>{value}</span></p>
                                                            )) :
                                                            <p> <span>Cartrdige details not available</span></p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </TabPane>
                            )) :
                            <TabPane tabId={TABS.BROTHER_PLUS_DEVICE_DETAILS}>
                                <div className="email-log-error">{t("CUSTOMER_DASHBOARD.DEVICE_AND_USAGE_DETAILS.NO_ACTIVE_DEVICES")}</div>
                            </TabPane>
                    }
                </TabContent>
            </div>
        </div>
    );
};

export default DeviceDetails;